import React from "react"

import * as s from "./ShopHeader.module.scss"

import { AnimateWrapper } from "../animate-wrapper/AnimateWrapper"

export const ShopHeader = ({ h1, title, image, category }) => {
  const backgroundImage = image.sourceUrl ? `url(${image.sourceUrl})` : "none"

  return (
    <div
      role="image"
      aria-label={image.altText ? image.altText : title}
      className={s.ShopHeader}
      style={{ backgroundImage: `${backgroundImage}` }}
    >
      <AnimateWrapper>
        {h1 && <h1 className={s.ShopHeader__h1}>{h1}</h1>}
        <h1 className={s.ShopHeader__title}>{title}</h1>
        {category && <h2 className={s.ShopHeader__categoryTitle}>{category}</h2>}
      </AnimateWrapper>
    </div>
  )
}
